export const  TelefonosEnum  = Object.freeze({
    CELULAR: 1,
    FIJO: 2,
})